import React from 'react'
import { Modal, notification } from "antd";
import useFetchMataData from "../../../../../../Components/Hooks/useFetchMataData";
import { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as yup from 'yup';
import axiosInstance from "../../../../../../Services/axiosCommon";
import { CancelButton, SubmitButton } from "../../../../../../Components/Utils/Buttons";
import { NuInput, NuSelect, NuTextArea } from "../../../../../../Components/Utils/Input";
import FormikSelectTwo from "../../../../../../Components/Utils/Select";
import DropDownAdd from "../../../../../../Components/Utils/selectAdd";
import UseCatSubCatDropDown from "../../../../../../Components/Hooks/useCategoryDropDown";

function CreateSubMaterialPro({open,onCancel,Unit,Item,getData,projectId,itId,Category,Division,itemsCategory,refMatrialCategory=()=>{},Activity}) {
 
    // const {value:item } = useFetchMataData(`/dropdown/dropdown-details/`,"MatrialItem")
    // const { value: Unit } = useFetchMataData(
    //     `/dropdown/dropdown-details/`,
    //     "Unit_item"
    //   );
   
    const [api, contextHolder] = notification.useNotification();
    const [isLoading,setIsLoading] = useState(false);
   
    const [createNew, setCreateNew] = useState({
      
    projectId:"",
    title_id:"",
    item:"",
    category:"",
    division:"",
    quantity:"",
    unit:"",
    amount:"",
    hours:"",
    comments:""
             
    });
 
  
    const formik = useFormik({
      enableReinitialize: true,
      initialValues: createNew,
      validateOnChange: false,
      validateOnBlur: false,
      validationSchema:yup.object({
        item:yup.string().required("Item Name is Requried")
      }),
      onSubmit: (value,{resetForm}) => {    
        setIsLoading(true);
        const values = {
          ...value,
          projectId: Number(projectId),
          title_id: itId,
          
        }
        axiosInstance
        .post(`/material/`, values)
          .then((res) => {
            console.log(res);
            if (res.status === 201 || res.data.status == true) {
              setIsLoading(false);
              getData();
              resetForm();
              api.success({
                message: `Material Item Creation successfully`,
                description: res?.data?.msg || "Added In Tittle",
                placement: "bottomRight",
              });
              onCancel();
            } else {
              api.error({
                message: `Material Item  Creation failed`,
                description: res?.data?.msg || "Network error",
                placement: "bottomRight",
              });
              setIsLoading(false);
            }
          })
          .catch((err) => {
            api.error({
              message: `Material Item Creation failed`,
              description: err?.data?.msg || "Sever error (or) Network error",
              placement: "bottomRight",
            });
            setIsLoading(false);
          });
      },
    });
 
    
    useEffect(() => {
      const amount = formik?.values?.actual_quantity * formik?.values?.actual_Price
      formik.setFieldValue("amount", amount);
    }, [formik?.values?.actual_quantity,formik?.values?.actual_Price]);
  
    return (
      <>
      {contextHolder}
      <Modal
        open={open}
        title={"Create Material Item"}
        width={"50%"}
        className="my-modal"
        centered
        footer={[]}
        onCancel={onCancel}
      >
      <form onSubmit={formik.handleSubmit} >
        <div className=" w-full flex flex-wrap">

           <FormikSelectTwo
           
                label="Item"
                placeholder="Item"
                formik={formik}
                name="item"
                // Option={item}
                isRequired={true}
                Options={Activity}
                width="w-full "               
                 
            />
           <FormikSelectTwo
              type="text"
              label="Category"
              placeholder="Category"
              Options={itemsCategory}
              formik={formik}
              name="category"
              width="w-full md:w-1/2"
              // getFunc={refMatrialCategory}
              // categoryName={"MatrialCategory"}
              // displayProperty={"Add Category"}
              // isRequired={true}
            />
              <FormikSelectTwo
              label="Division"
              Options={Division}
              formik={formik}
              placeholder="Choose"
              name="division"
              width="w-full md:w-1/2"
          />
           <NuInput
                type="number"
                label=" Quantity"
                placeholder=" Quantity"
                formik={formik}
                name="quantity"
                width="w-full md:w-1/2"
              />
          <FormikSelectTwo
          label="Unit"
          width="w-full md:w-1/2"    
          formik={formik}
          placeholder="Choose"
          name="unit"
          Options={Unit}
          />
              
            
              <NuInput
                type="number"
                label="Amount"
                placeholder="Amount"
                formik={formik}
                name="amount"
                width="w-full md:w-1/2"
              />
            
             <NuTextArea
                  label="Comments"
                  placeholder="Comments"
                  formik={formik}
                  name="comments"
                //  new_width="w-full"
                width="w-full md:w-1/2"
                />
              <div className="w-full flex justify-end item-end float-right mx-auto md:mx-0 gap-2 mt-2 md:mr-4">
                <CancelButton handleClick={onCancel} />
                <SubmitButton isLoading={isLoading} />
              </div>
        </div>
        </form>
      </Modal>
      </>
    )
}

export default CreateSubMaterialPro